export const installationArtists = [
  {
    id: 'mountain-song',
    order: '04',
    tag: '4th Installation · Current',
    name: 'Citra & Novieta',
    role: 'Collaborative Installation',
    portrait: 'kin/assest/about/kininstallation/citra_novieta/citra_novieta.webp',
    mainImage: 'kin/assest/about/kininstallation/citra_novieta/art1.webp',
    accentColor: '#9B6B82',
    bio: null,
    instagram: null,
    collaborators: [
      {
        name: 'Citra Sasmita',
        bio: `Citra Sasmita (born in Tabanan, Bali, March 30, 1990) is a Balinese contemporary artist and mother whose work explores myths, history, gender, and the role of women in Balinese culture. She studied at Udayana University and Ganesha University of Education, developing her artistic practice through theater and illustration.

Her works have been exhibited internationally, including at the Barbican Centre, and major biennials such as São Paulo, Sharjah, Sydney, and Toronto. Through her art, Citra encourages empathy, awareness, and equality for women.`,
        instagram: 'https://www.instagram.com/citrasasmita_work',
      },
      {
        name: 'Novieta Tourisia',
        bio: `Novieta Tourisia (born in Jakarta, November 30, 1987) is a textile artisan, natural dye practitioner, writer, educator, and founder of Cinta Bumi Artisans based in Ubud, Bali. Working with natural dyes, barkcloth, textiles, and hand-stitching techniques, her practice is rooted in Indigenous knowledge, sustainability, and a deep connection to the earth.

For Novieta, motherhood, creative practice, and everyday care are closely intertwined.`,
        instagram: 'https://www.instagram.com/tourisia',
      },
    ],
    project: {
      name: 'Mountain Song',
      subtitle: 'Nyanyian Gunung — an immersive journey to ancestral stories.',
      logo: null,
      description: `Mountain Song (Nyanyian Gunung) is an interactive installation by Citra Sasmita, created in collaboration with Novieta Tourisia for KiNstallation. Inspired by the daily life and stories of the Bada Valley community in Poso, Central Sulawesi, the installation invites children to explore culture and nature through touch, movement, sound, and imagination.

Featuring a barkcloth-lined cave, a vine-covered tree, and playful ecoprinted creatures, the space offers a warm and immersive journey to reconnect with ancestral stories, nature, and tradition.`,
      videoId: null,
      images: [
        'kin/assest/about/kininstallation/citra_novieta/art1.webp',
        'kin/assest/about/kininstallation/citra_novieta/art2.webp',
        'kin/assest/about/kininstallation/citra_novieta/art3.webp',
      ],
    },
  },
  {
    id: 'eko-nugroho',
    order: '03',
    tag: '3rd Installation',
    name: 'Eko Nugroho',
    role: 'Contemporary Artist',
    portrait: 'kin/assest/about/eko-nugroho.webp',
    mainImage: 'kin/assest/about/asset_about_4.webp',
    accentColor: '#F58136',
    instagram: 'https://www.instagram.com/ekonugroho_studio/',
    bio: `Eko Nugroho is an internationally recognized contemporary artist based in Yogyakarta, one of Indonesia's most vital artistic hubs. A graduate of the Indonesian Institute of the Arts Yogyakarta, Eko's background in street art and community-based work forms the core of his artistic practice.

His multidisciplinary works range from painting, drawing, and embroidery to murals, sculpture, and video, deeply rooted in local traditions and the vibrant realities of urban life. His distinctive visual style—bold, colorful, and infused with the aesthetics of street art, graffiti, and comics—often delivers powerful social and political messages.`,
    project: {
      name: 'Save Our Future',
      subtitle: 'A world where childhood wonder and hope converge.',
      logo: 'kin/assest/about/title_about_3.webp',
      description: `'Save Our Future' by Eko Nugroho brings an imaginative landscape where childhood memories, fantasy, and hope converge—inviting both children and adults to reconnect with the wonder within themselves. Through his distinctive artistic language—playful characters, bold visual motifs, and surreal landscapes—Eko builds an imaginative universe that invites exploration, interaction, and quiet contemplation.`,
      videoId: 'qc0IySwSasA',
      images: [
        'kin/assest/about/asset_about_4.webp',
        'kin/assest/about/asset_about_10.webp',
        'kin/assest/about/asset_about_5.webp',
      ],
    },
  },
  {
    id: 'eldwin-pradipta',
    order: '02',
    tag: '2nd Installation',
    name: 'Eldwin Pradipta',
    role: 'New Media Artist',
    portrait: 'kin/assest/about/eldwin-pradipta.webp',
    mainImage: 'kin/assest/about/asset_about_6.webp',
    accentColor: '#2d7d9a',
    instagram: 'https://www.instagram.com/eldwinpradipta/',
    bio: `Eldwin Pradipta is a contemporary artist known for blending art and technology in groundbreaking ways. Starting his journey in new media art at Institut Teknologi Bandung in 2008, he gained recognition with a thesis project that reimagined traditional landscapes through digital projections, exploring environmental themes. His career took off with a debut at ArtJog 2012.

His notable works include a water-screen projection at Jakarta's Hotel Indonesia Roundabout for Independence Day and his award-winning installation Gold-Shaping The Future at Art Jakarta 2023, earning him the Treasury Art Prize and the title of Prestige Indonesia's "It Artist" of the Year.`,
    project: {
      name: 'Pola Pola Bejana',
      subtitle: 'The Vessel Patterns — history and art through interaction.',
      logo: 'kin/assest/about/title_about_2.webp',
      description: `The Vessel Patterns brings history, art, and interaction to life, creating an experience that is both meaningful and enjoyable. Inspired by antique vessels from China and the Netherlands—discovered in shipwrecks and ancient sites in East and West Java—this exhibition highlights Nusantara's significant role in global trade centuries ago.`,
      videoId: 'awG_LQvCUOE',
      images: [
        'kin/assest/about/asset_about_6.webp',
        'kin/assest/about/asset_about_12.webp',
        'kin/assest/about/asset_about_16.webp',
      ],
    },
  },
  {
    id: 'mang-moel',
    order: '01',
    tag: '1st Installation',
    name: 'Mulyana (Mang Moel)',
    role: 'Sensory Installation Artist',
    portrait: 'kin/assest/about/mangmole.webp',
    mainImage: 'kin/assest/about/asset_about_13.webp',
    accentColor: '#2d8c7a',
    instagram: 'https://www.instagram.com/mangmoel/',
    bio: `Mulyana, affectionately known as Mang Moel, is a visual artist celebrated for his vibrant, tactile installations that evoke the beauty of the natural world. Inspired by his visit to Alor Island in eastern Indonesia, Moel creates immersive environments that blend color, texture, and marine imagery.

Through his work, Moel invites visitors to reflect on the fragile ecosystems of Indonesia's seas—the corals, sea plants, and marine life that shelter countless creatures beneath the waves.`,
    project: {
      name: 'Imaji Laut Timur Nusantara',
      subtitle: 'Imagery Of Eastern Nusantara Seas',
      logo: 'kin/assest/about/title_about_1.webp',
      description: `Inspired by his visit to Alor Island, Moel invites us to admire the Indonesian seas. In a pink room reflecting eastern Indonesia's sands, we find corals, sea plants, and whale sharks. Moel highlights coral's role as a guardian, protecting fish and providing shelter. Fan coral withstands waves, creating calm spaces for marine life. Moel's work urges us to nurture the sea's goodness.`,
      videoId: 'iWff67-0APA',
      images: [
        'kin/assest/about/asset_about_13.webp',
        'kin/assest/about/asset_about_14.webp',
        'kin/assest/about/asset_about_15.webp',
      ],
    },
  },
];
